<p-timeline layout="horizontal" [dt]="{
   horizontal: {
      event: {
      content: {
         padding: 0
      }
      }
   }
}" [value]="timelineItems()">
  <ng-template #opposite let-event>
    <div class="text-center w-8 h-8 items-end justify-center flex mb-2">
      @if (event.date) {
        <small class="text-surface-500  block dark:text-surface-400">{{ event.date }}</small>
      }
    </div>
  </ng-template>
  <ng-template #content let-event>
    <div class="w-8 h-10 items-start justify-center flex mt-1">
      <p class="text-sm text-center">{{ event.status }}</p>
    </div>
  </ng-template>
  <ng-template #marker let-event>
        <span class="flex h-8 min-w-8 items-center justify-center text-white rounded-full z-10 shadow-sm "
              [class]="event.color">
            <i [class]="event.icon"></i>
        </span>
  </ng-template>
</p-timeline>
